export interface ClosedDayPayload {
  data: {
    type: string;
    attributes: {
      date: string;
      reason: string;
    };
  };
}

export const toClosedDay = (date: string, reason: string): ClosedDayPayload => ({
  data: {
    type: "closed_days",
    attributes: { date, reason },
  },
});
